module.exports = __webpack_public_path__ + "img/硼砂.683546dd.jpg";